var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cd_container py-5"},[_c('div',{staticClass:"cd_mini-hero"},[_c('div',{staticClass:"cd_mini-hero--content pr-5 pt-xl-5 "},[_vm._t("default")],2),_c('div',{staticClass:"cd_mini-hero--image",style:(_vm.cssVars())})])])}
var staticRenderFns = []

export { render, staticRenderFns }